import { createContext, useContext } from "react";

interface DrawerResizeContextValue {
  isHoveringEdge: boolean;
  isResizing: boolean;
}

export const DrawerResizeContext = createContext<DrawerResizeContextValue>({
  isHoveringEdge: false,
  isResizing: false
});

export const useDrawerResizeState = () => useContext(DrawerResizeContext);
